type SlugType = string | string[] | undefined

export const getPathNameFromSlug = (slug: SlugType): string => {
	if (!slug) return ''
	return Array.isArray(slug) ? slug.join('/') : slug
}
